import { useEffect, useState } from 'react'
import { ArrowsCounterClockwise } from '@phosphor-icons/react'
import { Icon } from '@shopflo/ui'
import { formatRelativeTime } from 'src/lib/utils/helpers'

interface SyncStatusProps {
  lastSyncedAt: Date | null
  isSyncing?: boolean
  onRefresh: () => void
}

export default function SyncStatus({ lastSyncedAt, isSyncing, onRefresh }: SyncStatusProps) {
  const [, setTick] = useState(0)
  useEffect(() => {
    const interval = setInterval(() => setTick(tick => tick + 1), 30000)
    return () => clearInterval(interval)
  }, [])

  const label = isSyncing ? 'Syncing' : lastSyncedAt ? `Synced ${formatRelativeTime(lastSyncedAt, new Date())}` : 'Synced'

  return (
    <div
      onClick={isSyncing ? undefined : onRefresh}
      className={`flex h-[18px] w-fit items-center gap-0.5 rounded-sm bg-black/[0.05] px-1 ${
        isSyncing ? '' : 'cursor-pointer'
      }`}
    >
      <span className='text-text-xs-medium text-zinc-600'>{label}</span>
      <Icon
        IconComponent={ArrowsCounterClockwise}
        size='xxs'
        className={`text-zinc-500 ${isSyncing ? 'animate-spin' : ''}`}
      />
    </div>
  )
}
